export default {
    languageSwitchLabel:"Changer de langue",
    examStructureLabel:"Structure de l'examen",
    pricingLabel:"Tarifs",
    examLabel:"Examen",
    aboutLabel:"À propos",
    contactLabel:"Contact",
}
